module.exports = __webpack_public_path__ + "WealthCare Saver HSA Investments User Guide.pdf";